import TviConnectCard from './TviConnectCard'

export default TviConnectCard
